import type { Language } from '@/shared/entities/Language'

export class CancelDeliveryReasonEntity {
  id?: number
  translations?: Array<{
    text?: string | null
    language?: Language
  }> | null
}